<template>
    <div>
        <NavbarStyleTwo />
        <PageTitle pageTitle="SEO-Optimierung" pageDesc="Bessere Sichtbarkeit bei Google" />
        <SeoDetails />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import SeoDetails from '../SingleService/SeoDetails'
import Footer from '../Layouts/Footer'

export default {
    name: 'SeoPage',
    setup() {
        useHead({
            title: 'SEO Wien - Suchmaschinenoptimierung | Benovium',
            meta: [
                { name: 'description', content: 'SEO-Optimierung aus Wien. Keyword-Recherche, technisches SEO, Content-Optimierung und Local SEO. Bessere Google-Rankings für Ihr Unternehmen.' },
                { property: 'og:title', content: 'SEO Wien - Benovium' },
                { property: 'og:description', content: 'Suchmaschinenoptimierung für bessere Google-Rankings.' },
                { property: 'og:url', content: 'https://benovium.com/services/seo' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/services/seo' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        PageTitle,
        SeoDetails,
        Footer,
    }
};
</script>
